  // "use client"

  import React, { useState, useEffect } from "react";
  import { Link } from 'react-router-dom';
  import "./Navbar.css";
  const Navbar = () => {

    
    // const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
      // const handleScroll = () => {
      //   setIsScrolled(window.scrollY > 50);
      // };

      // window.addEventListener("scroll", handleScroll);

  //     return () => {window.removeEventListener("scroll", handleScroll);
  // };
  }, []);

    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
      setIsMenuOpen(false); // Automatically close the menu when a link is clicked
    };

    return (
      <nav className={`navbar }`}>

          

        <button
          className={`hamburger ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <ul className={`nav-links ${isMenuOpen ? "nav-active" : ""}`}>
          <div className="inner-division-of-navbar-list">
          <li>
            <Link to="/Services" onClick={closeMenu}>
              Services
            </Link>
          </li>

          <li className="dropdown">
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Our Designs
              {/* <img src="assets/navbar-dropdown-arrow-white.png" alt="Dropdown" /> */}
            </Link>
            <ul className="dropdown-menu">
              <li>
                <Link to="custom-homes" onClick={closeMenu}>
                  Custom Home Design
                </Link>
              </li>
              {/* <li>
                <Link to="Community-Development" onClick={closeMenu}>
                  Community Development
                </Link>
              </li> */}
              {/* <li>
                <Link to="BuildingDesign" onClick={closeMenu}>
                  Building Design
                </Link>
              </li> */}
              <li>
                <Link to="InteriorDesign" onClick={closeMenu}>
                  Interior Design
                </Link>
              </li>
              <li>
                <Link to="KitchenDesign" onClick={closeMenu}>
                  Kitchen Design
                </Link>
              </li>
              <li>
                <Link to="BathroomDesign" onClick={closeMenu}>
                  Bathroom Design
                </Link>
              </li>
              {/* <li>
                <Link to="RenovationDesign" onClick={closeMenu}>
                  Renovation Design
                </Link>
              </li> */}
              {/* <li>
                <Link to="/gallery/video" onClick={closeMenu}>
                  Fascade Range
                </Link>
              </li> */}
            </ul>
          </li>

          </div>
          <div className="navbar-logo">
            <Link to="/" > <img
    src="/assets/urbancasa-updated-logo.png"
    alt="CGC Jhanjeri"
    className="logo"
    
  /></Link>

 
  {/* <img
    src="assets/cgc-jhanjeri-naac-white.png"
    alt="NAAC Accredited"
    className="naac-logo"
  /> */}
  {/* <img src="assets/ecell-logo-with-bg.jpg" alt="" className="venture-nest-logo-bg-removed" /> */}
  </div>
  <div className="inner-division-of-navbar-list">

          <li>
            <Link to="/contact" onClick={closeMenu}>
              Build With Us
            </Link>
          </li>
          {/* <li>

            
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li> */}

<li>
            <Link to="/About-Urban-Casa" onClick={closeMenu}>
              About
            </Link>
          </li>
          {/* <li className="join-us-btn-navbar-extra">
            <Link to="/joinus" onClick={closeMenu} className="navbar-links-joinus-btn-text">
              Login
            </Link>
          </li> */}
          {/* <li className="join-us-btn-navbar-extra">
  <a 
    href="https://urbancasaadmin.web.app/" 
    target="_blank"  // Opens in a new tab
    rel="noopener noreferrer"  // Improves security
    className="navbar-links-joinus-btn-text"
  >
    Login
  </a>
</li> */}

        
        </div>
          {/* <li>
            <Link href="/latestnews" onClick={closeMenu}>
              Latest News
            </Link>
          </li> */}
          {/* <li className="dropdown">
            <Link href="/latestnews" onClick={closeMenu}>
              Latest News
              <img src="assets/navbar-dropdown-arrow-white.png" alt="Dropdown" />
            </Link>
            <ul className="dropdown-menu">
              <li>
                <Link href="/pastnews" onClick={closeMenu}>
                  Past News
                </Link>
              </li>
              <li>
                <Link href="/presentnews" onClick={closeMenu}>
                  Present News
                </Link>
              </li>
              <li>
                <Link href="/futurenews" onClick={closeMenu}>
                  Future News
                </Link>
              </li>
            </ul>
          </li> */}
          
        
      
  {/*       
          <li className="dropdown">
            <Link href="#" onClick={(e) => e.preventDefault()}>
              Our Team
              <img src="assets/navbar-dropdown-arrow-white.png" alt="Dropdown" />
            </Link>
            <ul className="dropdown-menu">
              <li>
                <Link href="/member" onClick={closeMenu}>
                  Ecell Team
                </Link>
              </li>
              <li>
                <Link href="/developedPage" onClick={closeMenu}>
              Developed By
                </Link>
              </li>
            </ul>
          </li> */}
          
        </ul>
        {/* <div className="navbar-logo">
          <img
            src="assets/cgc-jhanjeri-logo-white.png"
            alt="CGC Jhanjeri"
            className="logo"
          />
          <img
            src="assets/cgc-jhanjeri-naac-white.png"
            alt="NAAC Accredited"
            className="naac-logo"
          />
        </div> */}
      </nav>
    );
  };

  export default Navbar;
